import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { Settings } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings" component={Settings} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/main/routes.js